import { render, staticRenderFns } from "./TournamentSale.vue?vue&type=template&id=244e7121&lang=pug"
import script from "./TournamentSale.vue?vue&type=script&lang=js"
export * from "./TournamentSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports